var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", [_c("el-backtop", {
    attrs: {
      bottom: 100
    }
  }, [_c("div", {
    staticStyle: {
      height: "100%",
      width: "100%",
      "background-color": "var(--el-bg-color-overlay)",
      "box-shadow": "var(--el-box-shadow-lighter)",
      "text-align": "center",
      "line-height": "40px",
      color: "#1989fa",
      display: "flex",
      "align-items": "center",
      "justify-content": "center",
      "border-radius": "50%"
    }
  }, [_c("i", {
    staticClass: "el-icon-arrow-up",
    staticStyle: {
      "font-size": "20px"
    }
  })])]), _c("el-row", {
    staticClass: "panel-group filter-group",
    attrs: {
      gutter: 10
    }
  }, [_c("el-col", {
    staticClass: "filter-col",
    attrs: {
      span: 8
    }
  }, [_c("el-select", {
    staticClass: "branch-select",
    attrs: {
      filterable: "",
      clearable: "",
      loading: _vm.branchListLoading,
      name: "branchId",
      placeholder: "Select Branch",
      "aria-label": "Select Branch"
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.branchId,
      callback: function ($$v) {
        _vm.branchId = $$v;
      },
      expression: "branchId"
    }
  }, _vm._l(_vm.branchList, function (branch) {
    return _c("el-option", {
      key: branch.id,
      attrs: {
        label: branch.code,
        value: branch.id
      }
    });
  }), 1), _vm._isAdminRoles() ? _c("el-checkbox", {
    staticClass: "exclude-checkbox",
    attrs: {
      "aria-label": "Exclude Branches Checkbox"
    },
    on: {
      change: _vm.onCheckboxChange
    },
    model: {
      value: _vm.excludeBranches,
      callback: function ($$v) {
        _vm.excludeBranches = $$v;
      },
      expression: "excludeBranches"
    }
  }, [_vm._v(" Uncheck to include branch ")]) : _vm._e()], 1), _c("el-col", {
    staticClass: "filter-col",
    attrs: {
      span: 8
    }
  }, [_vm._isAdminRoles() ? _c("el-autocomplete", {
    staticClass: "search-input",
    attrs: {
      "fetch-suggestions": _vm.searchSuggestions,
      placeholder: "Quick Search...",
      debounce: 300,
      "aria-label": "Quick Search"
    },
    on: {
      select: _vm.handleSelect
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function ({
        item
      }) {
        return [_c("div", {
          staticClass: "autocomplete-item"
        }, [_c("div", [_vm._v(_vm._s(item.value))]), _c("div", {
          staticClass: "separator"
        })])];
      }
    }], null, false, 2329515485),
    model: {
      value: _vm.query,
      callback: function ($$v) {
        _vm.query = $$v;
      },
      expression: "query"
    }
  }) : _vm._e()], 1), _vm.isSuperAdmin() ? _c("el-col", {
    staticClass: "filter-col",
    attrs: {
      span: 8
    }
  }, [_c("router-link", {
    attrs: {
      to: "/analytics"
    }
  }, [_c("el-button", {
    staticClass: "analytics-button",
    attrs: {
      type: "primary",
      "aria-label": "View Analytics"
    }
  }, [_vm._v(" View Analytics "), _c("i", {
    staticClass: "el-icon-arrow-right",
    staticStyle: {
      "margin-left": "5px"
    }
  })])], 1)], 1) : _vm._e()], 1), _vm.superAdmin ? _c("el-row", {
    staticClass: "panel-group",
    attrs: {
      gutter: 10
    }
  }, [_c("el-col", {
    staticClass: "card-panel-col",
    attrs: {
      xs: 12,
      sm: 6,
      lg: 6
    }
  }, [_c("router-link", {
    attrs: {
      to: `/report/salesReport/list?startDate=${_vm.currentFinancialYearDate.start}&endDate=${_vm.currentFinancialYearDate.end}` + (_vm.branchId ? "&branchId=" + _vm.branchId : "")
    }
  }, [_c("el-tooltip", {
    attrs: {
      content: "Shows the Current FY Sales",
      placement: "top"
    }
  }, [_c("div", {
    staticClass: "card-panel"
  }, [_c("div", {
    staticClass: "card-panel-description"
  }, [_c("div", {
    staticClass: "card-panel-text",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c("el-tag", [_vm._v("Current FY Sales")])], 1), _c("inr", {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold"
    },
    attrs: {
      number: _vm.totalFySales
    }
  })], 1)])])], 1)], 1), _c("el-col", {
    staticClass: "card-panel-col",
    attrs: {
      xs: 12,
      sm: 6,
      lg: 6
    }
  }, [_c("router-link", {
    attrs: {
      to: `report/paymentReport/list?startDate=${_vm.currentFinancialYearDate.start}&endDate=${_vm.currentFinancialYearDate.end}` + (_vm.branchId ? "&branchId=" + _vm.branchId : "")
    }
  }, [_c("el-tooltip", {
    attrs: {
      content: "Shows the Payments received in Current FY",
      placement: "bottom"
    }
  }, [_c("div", {
    staticClass: "card-panel"
  }, [_c("div", {
    staticClass: "card-panel-description"
  }, [_c("div", {
    staticClass: "card-panel-text",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c("el-tag", [_vm._v("Current FY Payments")])], 1), _c("inr", {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold"
    },
    attrs: {
      number: _vm.totalFyPayment
    }
  })], 1)])])], 1)], 1), _c("el-col", {
    staticClass: "card-panel-col",
    attrs: {
      xs: 12,
      sm: 6,
      lg: 6
    }
  }, [_c("router-link", {
    attrs: {
      to: "orders-dispatches/outstanding-list" + (_vm.branchId ? "?branchId=" + _vm.branchId : "")
    }
  }, [_c("el-tooltip", {
    attrs: {
      content: "Shows the Total Oustanding",
      placement: "bottom"
    }
  }, [_c("div", {
    staticClass: "card-panel"
  }, [_c("div", {
    staticClass: "card-panel-description"
  }, [_c("div", {
    staticClass: "card-panel-text",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c("el-tag", [_vm._v("Total Outstanding")])], 1), _c("inr", {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold"
    },
    attrs: {
      number: _vm.totalOutstandingAmount
    }
  })], 1)])])], 1)], 1), _c("el-col", {
    staticClass: "card-panel-col",
    attrs: {
      xs: 12,
      sm: 6,
      lg: 6
    }
  }, [_c("router-link", {
    attrs: {
      to: `/report/salesReport/list?startDate=${_vm.currentMonthDate.start}&endDate=${_vm.currentMonthDate.end}${_vm.branchId ? "&branchId=" + _vm.branchId : ""}`
    }
  }, [_c("el-tooltip", {
    attrs: {
      content: "Shows the Total Sales of Current Month",
      placement: "top"
    }
  }, [_c("div", {
    staticClass: "card-panel"
  }, [_c("div", {
    staticClass: "card-panel-description"
  }, [_c("div", {
    staticClass: "card-panel-text",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c("el-tag", [_vm._v("Current Month Sales")])], 1), _c("inr", {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold"
    },
    attrs: {
      number: _vm.currentMonthSales
    }
  })], 1)])])], 1)], 1)], 1) : _vm._e(), _vm.superAdmin ? _c("el-row", {
    staticClass: "panel-group",
    attrs: {
      gutter: 10
    }
  }, [_c("el-col", {
    staticClass: "card-panel-col",
    attrs: {
      xs: 12,
      sm: 6,
      lg: 6
    }
  }, [_c("router-link", {
    attrs: {
      to: `report/paymentReport/list?startDate=${_vm.currentMonthDate.start}&endDate=${_vm.currentMonthDate.end}${_vm.branchId ? "&branchId=" + _vm.branchId : ""}`
    }
  }, [_c("el-tooltip", {
    attrs: {
      content: "Shows the Total Payments Received in Current Month",
      placement: "top"
    }
  }, [_c("div", {
    staticClass: "card-panel"
  }, [_c("div", {
    staticClass: "card-panel-description"
  }, [_c("div", {
    staticClass: "card-panel-text",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c("el-tag", [_vm._v("Current Month Payments")])], 1), _c("inr", {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold"
    },
    attrs: {
      number: _vm.currentMonthPayments
    }
  })], 1)])])], 1)], 1), _c("el-col", {
    staticClass: "card-panel-col",
    attrs: {
      xs: 12,
      sm: 6,
      lg: 6
    }
  }, [_c("router-link", {
    attrs: {
      to: `/report/salesReport/list?startDate=${_vm.previousMonthDate.start}&endDate=${_vm.previousMonthDate.end}${_vm.branchId ? "&branchId=" + _vm.branchId : ""}`
    }
  }, [_c("el-tooltip", {
    attrs: {
      content: "Shows the Total Sales of Previous Month",
      placement: "top"
    }
  }, [_c("div", {
    staticClass: "card-panel"
  }, [_c("div", {
    staticClass: "card-panel-description"
  }, [_c("div", {
    staticClass: "card-panel-text",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c("el-tag", [_vm._v("Previous Month Sales")])], 1), _c("inr", {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold"
    },
    attrs: {
      number: _vm.previousMonthSales
    }
  })], 1)])])], 1)], 1), _c("el-col", {
    staticClass: "card-panel-col",
    attrs: {
      xs: 12,
      sm: 6,
      lg: 6
    }
  }, [_c("router-link", {
    attrs: {
      to: `report/paymentReport/list?startDate=${_vm.previousMonthDate.start}&endDate=${_vm.previousMonthDate.end}${_vm.branchId ? "&branchId=" + _vm.branchId : ""}`
    }
  }, [_c("el-tooltip", {
    attrs: {
      content: "Shows the Total Payments Received in Previous Month",
      placement: "top"
    }
  }, [_c("div", {
    staticClass: "card-panel"
  }, [_c("div", {
    staticClass: "card-panel-description"
  }, [_c("div", {
    staticClass: "card-panel-text",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c("el-tag", [_vm._v("Previous Month Payments")])], 1), _c("inr", {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold"
    },
    attrs: {
      number: _vm.previousMonthPayments
    }
  })], 1)])])], 1)], 1)], 1) : _vm._e(), _vm.superAdmin ? _c("el-row", {
    staticClass: "panel-group",
    attrs: {
      gutter: 10
    }
  }, [_c("el-col", {
    staticClass: "card-panel-col",
    attrs: {
      xs: 12,
      sm: 6,
      lg: 6
    }
  }, [_c("router-link", {
    attrs: {
      to: "ledgers/pending-ledgers" + (_vm.branchId ? "?branchId=" + _vm.branchId : "")
    }
  }, [_c("el-tooltip", {
    attrs: {
      content: "Shows the Total Number of Ledgers to be Approved by Super Admin and Payment Manager",
      placement: "top"
    }
  }, [_c("div", {
    directives: [{
      name: "permission",
      rawName: "v-permission",
      value: [_vm.SUPER_ADMIN, _vm.ADMIN, _vm.PAYMENT_MANAGER],
      expression: "[SUPER_ADMIN, ADMIN, PAYMENT_MANAGER]"
    }],
    staticClass: "card-panel"
  }, [_c("div", {
    staticClass: "card-panel-description"
  }, [_c("div", {
    staticClass: "card-panel-text",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c("el-tag", [_vm._v("Total Pending Ledgers")])], 1), _c("count-to", {
    staticClass: "card-panel-num",
    attrs: {
      "start-val": 0,
      "end-val": _vm.totalPendingLedgers,
      duration: 2600
    }
  })], 1)])])], 1)], 1), _c("el-col", {
    staticClass: "card-panel-col",
    attrs: {
      xs: 12,
      sm: 6,
      lg: 6
    }
  }, [_c("router-link", {
    attrs: {
      to: "orders-dispatches/advance-list" + (_vm.branchId ? "?branchId=" + _vm.branchId : "")
    }
  }, [_c("el-tooltip", {
    attrs: {
      content: "Shows the Advance Amount above Outstanding",
      placement: "top"
    }
  }, [_c("div", {
    directives: [{
      name: "permission",
      rawName: "v-permission",
      value: [_vm.SUPER_ADMIN, _vm.ADMIN],
      expression: "[SUPER_ADMIN, ADMIN]"
    }],
    staticClass: "card-panel"
  }, [_c("div", {
    staticClass: "card-panel-description"
  }, [_c("div", {
    staticClass: "card-panel-text"
  }, [_c("el-tag", [_vm._v("Total Advance")])], 1), _c("inr", {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold"
    },
    attrs: {
      number: _vm.totalAdvanceAmount
    }
  })], 1)])])], 1)], 1)], 1) : _vm._e(), _c("el-row", {
    directives: [{
      name: "permission",
      rawName: "v-permission",
      value: [_vm.SUPER_ADMIN, _vm.ADMIN, _vm.READ_ONLY],
      expression: "[SUPER_ADMIN, ADMIN, READ_ONLY]"
    }],
    staticClass: "panel-group",
    attrs: {
      gutter: 10
    }
  }, [_c("el-col", {
    attrs: {
      xs: 24,
      sm: 12,
      lg: 8
    }
  }), _c("el-col", {
    attrs: {
      xs: 24,
      sm: 12,
      lg: 8
    }
  })], 1), _c("el-row", {
    staticClass: "panel-group",
    attrs: {
      gutter: 10
    }
  }), !_vm._isInvoiceManager() ? _c("el-divider", {
    attrs: {
      "content-position": "left"
    }
  }, [_vm._v(" Ranges ")]) : _vm._e(), !_vm._isInvoiceManager() ? _c("el-row", {
    staticClass: "panel-group",
    attrs: {
      gutter: 10
    }
  }, _vm._l(_vm.rangeList, function (range) {
    return _c("el-col", {
      key: range.id,
      staticClass: "card-panel-col",
      attrs: {
        xs: 12,
        sm: 6,
        lg: 6
      }
    }, [_c("router-link", {
      attrs: {
        to: `/report/range-wise-report/list?startDate=${_vm.currentFinancialYearDate.start}&endDate=${_vm.currentFinancialYearDate.end}&rangeId=${range.id}` + (_vm.branchId ? "&branchId=" + _vm.branchId : "")
      }
    }, [_c("el-tooltip", {
      attrs: {
        content: `Shows the Current FY ${range.name} Sales`,
        placement: "top"
      }
    }, [_c("div", {
      staticClass: "card-panel"
    }, [_c("div", {
      staticClass: "card-panel-description"
    }, [_c("div", {
      staticClass: "card-panel-text",
      staticStyle: {
        "margin-bottom": "20px"
      }
    }, [_c("el-tag", [_vm._v(_vm._s(range.name))])], 1), _c("inr", {
      staticStyle: {
        "font-size": "16px",
        "font-weight": "bold"
      },
      attrs: {
        number: _vm.rangeTotals[range.key] || 0
      }
    })], 1)])])], 1)], 1);
  }), 1) : _vm._e(), _c("el-row", {
    staticClass: "panel-group",
    attrs: {
      gutter: 10
    }
  }, [_c("el-col", {
    staticClass: "card-panel-col",
    attrs: {
      xs: 12,
      sm: 8,
      lg: 6
    }
  }, [[_c("router-link", {
    attrs: {
      to: "/dealers/list" + (_vm.branchId ? "?branchId=" + _vm.branchId : "")
    }
  }, [_c("el-tooltip", {
    attrs: {
      content: "Shows the Total Number of Enabled Dealers",
      placement: "top"
    }
  }, [_c("div", {
    staticClass: "card-panel"
  }, [_c("div", {
    staticClass: "card-panel-icon-wrapper icon-people"
  }, [_c("svg-icon", {
    staticClass: "card-panel-icon",
    attrs: {
      name: "peoples"
    }
  })], 1), _c("div", {
    staticClass: "card-panel-description"
  }, [_c("div", {
    staticClass: "card-panel-text"
  }, [_c("el-tag", {
    attrs: {
      size: "mini"
    }
  }, [_vm._v(" Dealers ")])], 1), _c("count-to", {
    staticClass: "card-panel-num",
    attrs: {
      "start-val": 0,
      "end-val": _vm.dealerCount,
      duration: 2600
    }
  })], 1)])])], 1)]], 2), _c("el-col", {
    staticClass: "card-panel-col",
    attrs: {
      xs: 12,
      sm: 8,
      lg: 6
    }
  }, [[_c("router-link", {
    attrs: {
      to: "/agents/list"
    }
  }, [_c("el-tooltip", {
    attrs: {
      content: "Shows the Total Number of Enabled Agents"
    }
  }, [_c("div", {
    staticClass: "card-panel"
  }, [_c("div", {
    staticClass: "card-panel-icon-wrapper icon-message"
  }, [_c("svg-icon", {
    staticClass: "card-panel-icon",
    attrs: {
      name: "user"
    }
  })], 1), _c("div", {
    staticClass: "card-panel-description"
  }, [_c("div", {
    staticClass: "card-panel-text"
  }, [_c("el-tag", {
    attrs: {
      size: "mini"
    }
  }, [_vm._v(" Agents ")])], 1), _c("count-to", {
    staticClass: "card-panel-num",
    attrs: {
      "start-val": 0,
      "end-val": _vm.agentCount,
      duration: 2600
    }
  })], 1)])])], 1)]], 2), _c("el-col", {
    staticClass: "card-panel-col",
    attrs: {
      xs: 12,
      sm: 8,
      lg: 6
    }
  }, [[_c("router-link", {
    attrs: {
      to: "/product/list"
    }
  }, [_c("el-tooltip", {
    attrs: {
      content: "Shows the Total Number of Enabled Products",
      placement: "top"
    }
  }, [_c("div", {
    staticClass: "card-panel"
  }, [_c("div", {
    staticClass: "card-panel-icon-wrapper icon-shopping"
  }, [_c("svg-icon", {
    staticClass: "card-panel-icon",
    attrs: {
      name: "shopping"
    }
  })], 1), _c("div", {
    staticClass: "card-panel-description"
  }, [_c("div", {
    staticClass: "card-panel-text"
  }, [_c("el-tag", {
    attrs: {
      size: "mini"
    }
  }, [_vm._v(" Products ")])], 1), _c("count-to", {
    staticClass: "card-panel-num",
    attrs: {
      "start-val": 0,
      "end-val": _vm.productscount,
      duration: 3000
    }
  })], 1)])])], 1)]], 2)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };